import * as React from "react";
import { config } from "@/shared/lib/config";
import { fetchLookupForInfinite, hydrateLookupItem } from "@/shared/lib/utils";
import { FormMultiCombobox } from "@/shared/ui/FormMultiCombobox";

type UserItem = { id: string; name: string };

type QCInspectorUserIdsFieldProps = {
  departmentId: string | null | undefined;
  inspectorPositionId: string | null | undefined;
};

export function QCInspectorUserIdsField({
  departmentId,
  inspectorPositionId,
}: QCInspectorUserIdsFieldProps) {
  const preloadInspectors = React.useCallback(
    async (ids: string[]): Promise<UserItem[]> => {
      const url = `${config.apiUrl}/qc/users/lookup`;
      const clean = ids.filter((id) => id?.trim());
      const arr = await Promise.all(
        clean.map((id) => hydrateLookupItem<UserItem>(url, id)),
      );
      return arr.filter((x): x is UserItem => x != null);
    },
    [],
  );

  return (
    <FormMultiCombobox<UserItem>
      name="inspectorUserIds"
      label="ຜູ້ກວດສອບ (ກຳນົດຕົວບຸກຄົນ)"
      hint="ເລືອກພະນັກງານທີ່ຮັບຜິດຊອບຕົວຈິງໃນການກວດສອບ (ບໍ່ບັງຄັບ, ຫຼາຍຄົນໄດ້)"
      queryKey={[
        "qc-users-inspectors",
        departmentId ?? "",
        inspectorPositionId ?? "",
      ]}
      queryFn={(args) => {
        const extra: Record<string, string> = {};
        if (departmentId) extra.departmentId = departmentId;
        if (inspectorPositionId) extra.positionIds = inspectorPositionId;
        return fetchLookupForInfinite(
          `${config.apiUrl}/qc/users/lookup`,
          args,
          Object.keys(extra).length ? extra : undefined,
        );
      }}
      preloadQueryFn={preloadInspectors}
      getLabel={(item) => item.name ?? item.id}
      getValue={(item) => item.id}
      placeholder="ຄົ້ນຫາແລະເລືອກພະນັກງານ (ຫຼາຍຄົນ)"
      clearable
      className="w-full"
    />
  );
}
